import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { FloatingCart } from "./FloatingCart";
import { Seo } from "./Seo";
import { setLenis, getLenis, scrollToTarget } from "../../lib/lenis";
import { Toaster } from "../ui/sonner";

const useSmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let id = requestAnimationFrame(function raf(t) {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    });
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      setLenis(null);
    };
  }, []);
};

const useRouteScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) scrollToTarget(el);
      }, 120);
      return () => clearTimeout(t);
    }
    const l = getLenis();
    if (l) l.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
};

export default function Layout() {
  useSmoothScroll();
  useRouteScroll();
  return (
    <div className="site-root min-h-screen bg-[#0B2216] text-[#F7F4EB]">
      <Seo />
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingCart />
      <Toaster position="bottom-center" theme="dark" />
    </div>
  );
}
